import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { getLanguageFromUrl } from '../language';

@Injectable({ providedIn: 'root' })
export class ApiService {



  constructor( private http: HttpClient ){}

  get userLanguage(): string {
    return getLanguageFromUrl();// || getDefaultLanguage();
  }

  get<T>(route: ApiRoute, params?: string[], prefix: string = '/get'): Observable<T> {
    const url: string = environment.apiUrl + prefix + `/${this.userLanguage}` + route + (params ? this.serializeParams(params): '');
    return this.http.get<T>(url);
  }

  serializeParams(params: string[]): string {
    let paramsStr: string = '';
    for(const param of params) {
      paramsStr += paramsStr.length ? '&' : '?';
      paramsStr += param;
    }

    return paramsStr;
  }

}

export enum ApiRoute {
  // maestros
  TIPOLOGIA = '/tipomaterial',
  ACABADO = '/acabado',
  COLOR = '/colormaterial',
  USOS = '/usomaterial',
  ORIGEN = '/continente',
  ESPESOR = '/espesor',
  DISPONIBILIDAD = '/disponibilidad',
  RANGO_PRECIO = '/rangoprecio',
  CARACTERISTICAS = '/caracteristicamaterial',
  //materiales
  CARACTERISTICAS_MATERIAL = '/caracteristicaspormaterial',
  MATERIALES = '/material',
  MATERIALES_SIMILARES = '/materialsimilar',
  USOS_MATERIAL = '/usospormaterial',
  IMAGEN_LIBRO = '/imagenlibro', // boockmatch
  // stock
  STOCK = '/stock',
  STOCK_COUNT = '/stock',
  // detalles
  DETALLE = '/detallestock'
}
